<div class="wrapper">
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/terminal">Terminal</a></li>
              <li class="breadcrumb-item active" *ngIf="!!id">Update Terminal</li>
              <li class="breadcrumb-item active" *ngIf="!id">Add Terminal</li>
            </ol>
          </div>
          <h4 class="page-title" *ngIf="!!id">Update Terminal</h4>
          <h4 class="page-title" *ngIf="!id">Add Terminal</h4>
        </div>
      </div>
    </div>
    <!-- end page title *ngIf="!id" -->
    <div class="row">
      <div class="col-12">
        <div class="card-box">

          <form [formGroup]="terminalForm" *ngIf="terminalUpdate" role="form" autocomplete="off">

            <div class="row" *ngIf="raiseWarning">
              <div class="col-md-12 form-horizontal px-3">
                <ngb-alert [dismissible]="false">
                  <strong>Warning!</strong> {{warning}}
                </ngb-alert>
              </div>
            </div>

            <div class="row" *ngIf="raiseDanger">
              <div class="col-md-12 form-horizontal px-3">
                <ngb-alert type="danger" [dismissible]="false">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>

            <ul ngbNav #nav="ngbNav" class="nav nav-tabs">
              <li [ngbNavItem]="1">
                <a ngbNavLink>Terminal information</a>
                <ng-template ngbNavContent>

                  <div class="row form-horizontal">
                    <div class="col-md-6 form-horizontal px-3">
                      <div class="form-group row border-bottom my-3">
                        <label class="col-3 col-form-label font-weight-bold">Terminal</label>
                      </div>
                      <div class="form-group row" *ngIf="editExistingContent">
                        <label for="terminalConfig" class="col-3 col-form-label">Terminal Config</label>
                        <div class="col-9">
                          <ng-select2 id="terminalConfig" formControlName="terminalConfig" (valueChanged)="updateForm()" [data]="terminalConfigsSelect2" [options]="select2options" [placeholder]="'Please select a terminal config...'"></ng-select2>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayMPOSContent">
                        <label for="merchantNumber" class="col-3 col-form-label">Merchant Number</label>
                        <div class="col-9">
                          <input formControlName="merchantNumber" id="merchantNumber" placeholder="Merchant Number" required class="form-control" maxlength="15">
                          <ul *ngIf="submitted || terminalForm.controls.merchantNumber.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.merchantNumber.hasError('required')" class="parsley-required">Merchant number is required.</li>
                            <li *ngIf="terminalForm.controls.merchantNumber.hasError('minlength')" class="parsley-error">Merchant number must be atleast 15 characters.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayEscoket">
                        <label for="storeId" class="col-3 col-form-label">Store</label>
                        <div class="col-9">
                          <ng-select2 formControlName="storeId" id="storeId" [data]="storesItems" [options]="select2options" placeholder="Select store"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.storeId.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.storeId.hasError('required')" class="parsley-required">Store Id is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayEscoket">
                        <label for="storeId" class="col-3 col-form-label">Lane profile</label>
                        <div class="col-9">
                          <ng-select2 formControlName="laneProfile" id="laneProfile" [data]="laneProfileItems" [options]="select2options" placeholder="Lane profiles" (valueChanged)="updateProfileInformation($event)"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.laneProfile.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.laneProfile.hasError('required')" class="parsley-required">Lane profile is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayMPOSContent">
                        <label for="terminalId" class="col-3 col-form-label">Terminal Id</label>
                        <div class="col-9">
                          <input formControlName="terminalId" class="form-control" id="terminalId" placeholder="Terminal Id" maxlength="8">
                          <ul *ngIf="submitted || terminalForm.controls.terminalId.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.terminalId.hasError('required')" class="parsley-required">Terminal Id is required.</li>
                            <li *ngIf="terminalForm.controls.terminalId.hasError('minlength')" class="parsley-error">Terminal Id must be atleast 8 characters.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="terminalNumber" class="col-3 col-form-label">Terminal Number</label>
                        <div class="col-9">
                          <input formControlName="terminalNumber" class="form-control" id="terminalNumber" placeholder="Terminal Number" maxlength="4">
                          <ul *ngIf="submitted || terminalForm.controls.terminalNumber.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.terminalNumber.hasError('required')" class="parsley-required">Terminal number is required.</li>
                            <!-- <li *ngIf="terminalForm.controls.terminalNumber.hasError('minlength')" class="parsley-error">Terminal number must be atleast 4 characters.</li> -->
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="isSerialNrVisible">
                        <label for="serialNumber" class="col-3 col-form-label">Serial Number</label>
                        <div class="col-9">
                          <input formControlName="serialNumber" class="form-control" id="serialNumber" placeholder="Serial Number">
                          <ul *ngIf="submitted || terminalForm.controls.serialNumber.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.serialNumber.hasError('required')" class="parsley-required">Serial number is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="terminalType" class="col-3 col-form-label">Terminal Type</label>
                        <div class="col-9">
                          <ng-select2 id="terminalType" formControlName="terminalType" [data]="termTypes" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.terminalType.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.terminalType.hasError('required')" class="parsley-required">Terminal type is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="productProfile" class="col-3 col-form-label">Product Profile</label>
                        <div class="col-9">
                          <ng-select2 id="productProfile" [disabled]="!canEditProductProfile" formControlName="productProfile" [data]="productProfiles" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.productProfile.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.productProfile.hasError('required')" class="parsley-required">Product profile is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="terminalCapabilities" class="col-3 col-form-label">Terminal Capabilities</label>
                        <div class="col-9">
                          <ng-select2 id="terminalCapabilities" [disabled]="!canEditTerminalCapability" formControlName="terminalCapabilities" [data]="capabilityProfiles" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.terminalCapabilities.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.terminalCapabilities.hasError('required')" class="parsley-required">Terminal capability profile is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="commsProfile" class="col-3 col-form-label">Comms Profile</label>
                        <div class="col-9">
                          <ng-select2 id="commsProfile" [disabled]="!canEditCommsProfile" formControlName="commsProfile" [data]="commsProfiles" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.commsProfile.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.commsProfile.hasError('required')" class="parsley-required">Comms profile is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayMPOSContent">
                        <label for="term_active" class="col-3 col-form-label">Terminal Active</label>
                        <div class="col-9">
                          <input formControlName="isTerminalActive" type="checkbox" id="term_active" placeholder="term_active">
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="manualPanEntry">
                        <label for="panEntry" class="col-3 col-form-label">Manual Pan Entry</label>
                        <div class="col-9">
                          <input formControlName="isManualPan" [disabled]="manualPanEntry" type="checkbox" id="panEntry" placeholder="Manual Pan Entry">
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="isContactless" class="col-3 col-form-label">Contactless</label>
                        <div class="col-9">
                          <input formControlName="isContactless" (change)="setContactless($event)" type="checkbox" id="isContactless" placeholder="Contactless">
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 form-horizontal px-3">
                      <div class="form-group row border-bottom my-3" *ngIf="displayContent">
                        <label class="col-3 col-form-label font-weight-bold">Terminal interactions</label>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label class="col-3 col-form-label">Banking window</label>
                        <div class="col-9">
                          <ng-select2 id="ctrlBankingWindow" [disabled]="disableInteractions" formControlName="bankingWindowTime" [data]="terminalInteractionBankingWindowTimes" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.bankingWindowTime.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.bankingWindowTime.hasError('required')" class="parsley-required">Banking window is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="terminalNumber" class="col-3 col-form-label" style="padding-left:10px;">Conn</label>
                        <div class="col-9">
                          <input formControlName="bankingWindowConn" class="form-control" id="bankingWindowConn" placeholder="Conn">
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="terminalNumber" class="col-3 col-form-label" style="padding-left:10px;">Wait</label>
                        <div class="col-9">
                          <input formControlName="bankingWindowWait" class="form-control" id="bankingWindowWait" placeholder="Wait">
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label class="col-3 col-form-label">Parameter download day</label>
                        <div class="col-9">
                          <ng-select2 id="parameterDownloadDay" [disabled]="disableInteractions" formControlName="parameterDownloadWindowDay" [data]="parameterDownloadInteractionDays" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.parameterDownloadWindowDay.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.parameterDownloadWindowDay.hasError('required')" class="parsley-required">Parameter download day is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label class="col-3 col-form-label">Parameter download window</label>
                        <div class="col-9">
                          <ng-select2 id="ctrl" [disabled]="disableInteractions" formControlName="parameterDownloadWindowTime" [data]="terminalInteractionParameterTimes" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || terminalForm.controls.parameterDownloadWindowTime.touched" class="parsley-errors-list filled">
                            <li *ngIf="terminalForm.controls.parameterDownloadWindowTime.hasError('required')" class="parsley-required">Parameter download window is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="terminalNumber" class="col-3 col-form-label" style="padding-left:10px;">Conn</label>
                        <div class="col-9">
                          <input formControlName="parameterDownloadWindowConn" class="form-control" id="interactionTimeConn" placeholder="Conn" maxlength="4">
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="terminalNumber" class="col-3 col-form-label" style="padding-left:10px;">Wait</label>
                        <div class="col-9">
                          <input formControlName="parameterDownloadWindowWait" class="form-control" id="interactionTimeWait" placeholder="Wait" maxlength="4">
                        </div>
                      </div>

                      <div class="form-group row" *ngIf="displayContent">
                        <label for="terminalNumber" class="col-12 col-form-label">* Conn and wait times are displayed in minutes values</label>
                      </div>

                    </div>
                  </div>

                  <div class="form-group mb-0 justify-content-end row">
                    <button type="submit" [style]="DeleteButton" class="btn btn-danger waves-effect waves-light float-left m-2" (click)="deleteInactiveTerminal()">
                      Delete <i class="mdi mdi-delete-outline"></i>
                    </button>
                    <button type="submit" [style]="AddEditButton" class="btn btn-info waves-effect waves-light float-right m-2" (click)="saveTerminal()">
                      Save <i class="mdi mdi-content-save"></i>
                    </button>
                  </div>

                </ng-template>
              </li>
              <li [ngbNavItem]="2" *ngIf="hasCustomTags">
                <a ngbNavLink>Custom parameters </a>
                <ng-template ngbNavContent>
                  <div class="row">
                    <div class="col-12 mb-2">
                      <div class="row form-horizontal">

                        <div class="col-md-6 form-horizontal px-3">
                          <div class="form-group row border-bottom my-3">
                            <label class="col-3 col-form-label font-weight-bold">Terminal Group </label>
                          </div>

                          <div class="form-group row">
                            <label for="setCustonParam" class="col-3 col-form-label">Terminal group</label>

                            <div class="col-9">
                              <div class="input-group">
                                <ng-select2 id="selectedGroup" [(ngModel)]="selectedGroup" [ngModelOptions]="{standalone: true}"
                                            [data]="mapTerminalGroupTags"
                                            [options]="select2options" style="width:300px" placeholder="Custom tags"></ng-select2>

                                <div class="input-group-append">
                                  <button class="btn btn-info waves-effect waves-light" (click)="addTerminalGroups(selectedGroup)" type="button">add group<i class="mdi mdi-plus"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <ng-container>

                            <div *ngIf="terminalGroupMappedFields && terminalGroupMappedFields.length > 0">
                              <div class="form-group row" *ngFor="let mappedField of mappedFieldsGroupFC">

                                <label style="width:300px" for="{{mappedField.terminalGroupMappedFields.term_group_name}}" class="col-3 col-form-label">{{mappedField.terminalGroupMappedFields.term_group_name}}</label>
                                <div class="col-9">
                                  <div class="input-group">
                                    <div class="input-group-append">
                                      <button class="btn btn-icon waves-effect waves-light btn-outline-primary" (click)="ViewCustomParameters(mappedField.terminalGroupMappedFields.term_group_name)" type="button">View custom parameters<i class="mdi mdi-mini-sd"></i></button>
                                      &nbsp;
                                      <button class="btn btn-outline-warning  waves-effect waves-light" (click)="deleteTerminalGroup(mappedField.terminalGroupMappedFields.term_group_name)" type="button" [style]="viewOnlyRight">Delete<i class="mdi mdi-delete"></i></button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </ng-container>
                        </div>
                        <div class="col-md-6 form-horizontal px-3">
                          <div class="form-group row border-bottom my-3" *ngIf="terminalParamMappedFields && terminalParamMappedFields.length > 0">
                            <label class="col-12 col-form-label font-weight-bold">Custom parameters {{selectedTerminalGroup}}</label>
                          </div>

                          <div class="form-group row my-3" *ngIf="noCustomParamterSet">
                            <div class="col-md-12 form-horizontal px-3">
                              <ngb-alert [dismissible]="false">
                                <strong>Warning!</strong> {{noCustomParamterMessage}}
                              </ngb-alert>
                            </div>
                          </div>

                          <ng-container>
                            <div *ngIf="terminalParamMappedFields && terminalParamMappedFields.length > 0">
                              <div class="form-group row" *ngFor="let mappedField of mappedFieldsFC; let i = index;">
                                <label style="width:300px" for="{{mappedField.terminalParamMappedFields.customTag}}" class="col-3 col-form-label">{{mappedField.terminalParamMappedFields.customTag}}</label>
                                <div class="col-9">
                                  <div class="input-group">
                                    <input [(formControl)]="mappedField.formControl" [style]="EditCustomParamValue" id="{{mappedField.terminalParamMappedFields.customTag}}" (blur)="defaultValueChange(mappedField.formControl.value, mappedField.terminalParamMappedFields.customTag, mappedField.terminalParamMappedFields.value)" style="width:250px" [class]="cssClass" [ngModelOptions]="{standalone: true}" placeholder="Value" maxlength="15">
                                    <div class="input-group-append">
                                      <button type="submit" [style]="EditCustomParam" class="btn btn-info waves-effect waves-light" (click)="UpdateCustomParam(mappedField.terminalParamMappedFields.customTag, mappedField.formControl.value, mappedField.terminalParamMappedFields.value)">
                                        update
                                      </button>
                                    </div>
                                    <label for="{{mappedField.terminalParamMappedFields.customTag}}" id="{{mappedField.terminalParamMappedFields.value}}{{mappedField.terminalParamMappedFields.value}}" class="col-9 col-form-label"></label>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </ng-container>
                        </div>

                      </div>
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="tab-pane">
            </div>
          </form>

        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
